import { Box, Button, Dialog, DialogProps, Grid } from "@material-ui/core";
import {
    Collections,
    IncidentReviewRequest,
    IncidentReviewRequestDefault,
    StatusIncidentReviewRequest,
    StatusIncidentReviewRequestDescription,
} from "api";
import { Form, Formik } from "formik";
import { useSnackbar } from "notistack";
import React, { useMemo } from "react";
import { useFirestore } from "react-redux-firebase";
import {
    InputFieldFormik,
    SelectFieldFormik,
    SelectOption,
    SubmitButton,
    Title,
    yupRequiredField,
} from "ui/componentes";
import * as Yup from "yup";

interface IncidentReviewRequestAnswerDialogProps {
    reviewRequest?: IncidentReviewRequest;
}

const RequestReviewValidation = Yup.object().shape({
    answerDescription: Yup.string().required(yupRequiredField),
});

const IncidentReviewRequestAnswerDialog: React.FC<
    IncidentReviewRequestAnswerDialogProps & DialogProps
> = ({ reviewRequest, ...dialogProps }) => {
    const firestore = useFirestore();
    const { enqueueSnackbar } = useSnackbar();
    const statusOptions = useMemo<SelectOption[]>(() => {
        return [
            {
                label:
                    StatusIncidentReviewRequestDescription[
                        StatusIncidentReviewRequest.OPEN
                    ],
                value: StatusIncidentReviewRequest.OPEN,
            },
            {
                label:
                    StatusIncidentReviewRequestDescription[
                        StatusIncidentReviewRequest.ACCEPT
                    ],
                value: StatusIncidentReviewRequest.ACCEPT,
            },
            {
                label:
                    StatusIncidentReviewRequestDescription[
                        StatusIncidentReviewRequest.UNACCEPT
                    ],
                value: StatusIncidentReviewRequest.UNACCEPT,
            },
        ];
    }, []);

    return (
        <Formik
            enableReinitialize={true}
            initialValues={{
                ...IncidentReviewRequestDefault,
                ...reviewRequest,
            }}
            validationSchema={RequestReviewValidation}
            onSubmit={(values, { setSubmitting, resetForm }) => {
                firestore
                    .collection(Collections.INCIDENT_REVIEW_REQUESTS)
                    .doc(values.id)
                    .update(values)
                    .then(() => {
                        resetForm(IncidentReviewRequestDefault);
                        if (dialogProps.onClose) {
                            dialogProps.onClose({}, "escapeKeyDown");
                        }
                        enqueueSnackbar("Pedido de revisão atualizado", {
                            variant: "success",
                        });
                    })
                    .catch(() => {
                        enqueueSnackbar("Erro ao atualizar pedido de revisão", {
                            variant: "success",
                        });
                    })
                    .finally(() => setSubmitting(false));
            }}
        >
            {({ values, isSubmitting, resetForm }) => {
                return (
                    <Dialog
                        open={dialogProps.open}
                        maxWidth="md"
                        onClose={(event, reason) => {
                            if (dialogProps.onClose) {
                                dialogProps.onClose(event, reason);
                            }
                            resetForm(IncidentReviewRequestDefault);
                        }}
                    >
                        <Form>
                            <Box p={3}>
                                <Grid container spacing={1}>
                                    <Grid item xs={12}>
                                        <Title text="Reavalição de penalidade" />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <InputFieldFormik
                                            disabled
                                            id="description"
                                            name="description"
                                            label="Descrição"
                                            multiline
                                            rows={6}
                                            helperText={`Max.: ${values.description.length} / 300`}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <InputFieldFormik
                                            required
                                            id="answerDescription"
                                            name="answerDescription"
                                            label="Resposta"
                                            multiline
                                            rows={6}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <SelectFieldFormik
                                            required
                                            id="status"
                                            name="status"
                                            label="Status"
                                            options={statusOptions}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <Button
                                            fullWidth
                                            onClick={() => {
                                                if (dialogProps.onClose) {
                                                    dialogProps.onClose(
                                                        {},
                                                        "escapeKeyDown"
                                                    );
                                                }
                                                resetForm(
                                                    IncidentReviewRequestDefault
                                                );
                                            }}
                                        >
                                            Cancelar
                                        </Button>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <SubmitButton fullWidth>
                                            {isSubmitting
                                                ? "Salvando resposta"
                                                : "Salvar"}
                                        </SubmitButton>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Form>
                    </Dialog>
                );
            }}
        </Formik>
    );
};

export { IncidentReviewRequestAnswerDialog };
